var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.55 21.015l-7.93-7.98q-1.314.04-2.546.513q-1.232.473-2.164 1.283q-.256.196-.557.208q-.301.013-.515-.206q-.219-.22-.19-.54q.027-.32.277-.522q.902-.771 2.04-1.323q1.137-.552 2.37-.698L6.662 8.077q-.958.37-2.013 1.026q-1.055.657-1.957 1.453q-.25.207-.56.227q-.31.019-.524-.2q-.22-.22-.195-.527q.025-.308.256-.516q.896-.834 1.904-1.506t1.965-1.08L3.6 5.015q-.14-.14-.15-.344q-.01-.204.15-.363q.16-.16.354-.16q.194 0 .354.16l15.975 15.975q.165.165.165.366q0 .201-.165.366q-.166.14-.367.153q-.2.013-.366-.153ZM12 20.423q-.646 0-1.092-.449q-.446-.449-.446-1.09q0-.646.446-1.092q.446-.446 1.092-.446t1.092.446q.446.446.446 1.093q0 .64-.446 1.09q-.446.448-1.092.448Zm6.287-5.76q-.17.17-.39.167q-.22-.003-.39-.172l-.227-.228l-.234-.234l-2.08-2.08q.726.169 1.593.609q.866.44 1.668 1.14q.2.158.214.394t-.154.404Zm4.125-4.08q-.233.238-.55.203q-.318-.036-.587-.263q-1.858-1.667-4.23-2.595Q14.673 7 12 7q-.525 0-1.041.038q-.517.037-.959.112L8.72 5.87q.657-.166 1.458-.249q.8-.083 1.822-.083q3.01 0 5.638 1.057q2.627 1.057 4.693 2.92q.25.214.275.531q.025.317-.194.537Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOff);
export default __webpack_public_path__ + "static/media/wifi-off.f5e50a60b6612d4cd923f0f664bd7532.svg";
export { ForwardRef as ReactComponent };